var map = {
	"./AlbertoFaini.png": 6122,
	"./AlessandraBrunetti.png": 2623,
	"./AntonioMaggini.png": 1021,
	"./BaldoPipitone.png": 5984,
	"./ClaudiaRagonesi.png": 8010,
	"./CristinaGarbuglia.png": 6382,
	"./FaustaRiscaldati.png": 9299,
	"./LucaPipitone.png": 6729,
	"./ManuelaGhirardi.png": 912,
	"./Max.png": 5015,
	"./NadiaColetta.png": 2916,
	"./RiccardoBonati.png": 7809,
	"./RiccardoC.png": 6471,
	"./RiccardoCeppari.png": 5171,
	"./SilviaBorriello.png": 2618
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9331;